import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './DestinationsPage.css';

const DestinationsPage = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDestination, setSelectedDestination] = useState(null);

  const nigerianDestinations = [
    {
      id: 1,
      city: 'Lagos',
      code: 'LOS',
      image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80',
      price: '₦45,000'
    },
    {
      id: 2,
      city: 'Abuja',
      code: 'ABV',
      image: 'https://images.unsplash.com/photo-1564501049412-61c2a3083791?auto=format&fit=crop&w=800&q=80',
      price: '₦52,000'
    },
    {
      id: 3,
      city: 'Port Harcourt',
      code: 'PHC',
      image: 'https://images.unsplash.com/photo-1514565131-fce0801e5785?auto=format&fit=crop&w=800&q=80',
      price: '₦48,000'
    },
    {
      id: 4,
      city: 'Kano',
      code: 'KAN',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80',
      price: '₦55,000'
    },
    {
      id: 5,
      city: 'Enugu',
      code: 'ENU',
      image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=800&q=80',
      price: '₦50,000'
    },
    {
      id: 6,
      city: 'Benin',
      code: 'BNI',
      image: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?auto=format&fit=crop&w=800&q=80',
      price: '₦47,000'
    }
  ];

  const internationalDestinations = [
    {
      id: 1,
      city: 'Dubai',
      code: 'DXB',
      image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=800&q=80',
      price: '₦420,000'
    },
    {
      id: 2,
      city: 'London',
      code: 'LHR',
      image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=800&q=80',
      price: '₦680,000'
    },
    {
      id: 3,
      city: 'Accra',
      code: 'ACC',
      image: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=800&q=80',
      price: '₦95,000'
    },
    {
      id: 4,
      city: 'Johannesburg',
      code: 'JNB',
      image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80',
      price: '₦580,000'
    },
    {
      id: 5,
      city: 'Istanbul',
      code: 'IST',
      image: 'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?auto=format&fit=crop&w=800&q=80',
      price: '₦520,000'
    },
    {
      id: 6,
      city: 'Doha',
      code: 'DOH',
      image: 'https://images.unsplash.com/photo-1505142468610-359e7d316be0?auto=format&fit=crop&w=800&q=80',
      price: '₦450,000'
    }
  ];

  const flightDeals = [
    {
      id: 1,
      airline: '✈️',
      route: 'Lagos → Dubai',
      dates: 'Dec 15 - Dec 22',
      price: '₦380,000',
      originalPrice: '₦420,000'
    },
    {
      id: 2,
      airline: '✈️',
      route: 'Abuja → London',
      dates: 'Jan 10 - Jan 20',
      price: '₦620,000',
      originalPrice: '₦680,000'
    },
    {
      id: 3,
      airline: '✈️',
      route: 'Lagos → Accra',
      dates: 'Dec 20 - Dec 27',
      price: '₦85,000',
      originalPrice: '₦95,000'
    },
    {
      id: 4,
      airline: '✈️',
      route: 'Lagos → Johannesburg',
      dates: 'Feb 5 - Feb 15',
      price: '₦520,000',
      originalPrice: '₦580,000'
    },
    {
      id: 5,
      airline: '✈️',
      route: 'Abuja → Istanbul',
      dates: 'Mar 1 - Mar 10',
      price: '₦480,000',
      originalPrice: '₦520,000'
    }
  ];

  const regions = [
    {
      id: 1,
      name: 'Africa',
      image: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=1200&q=80'
    },
    {
      id: 2,
      name: 'Europe',
      image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=1200&q=80'
    },
    {
      id: 3,
      name: 'Middle East',
      image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1200&q=80'
    },
    {
      id: 4,
      name: 'North America',
      image: 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?auto=format&fit=crop&w=1200&q=80'
    }
  ];

  const handleSearch = (e) => {
    e.preventDefault();
    // Navigate to book flight page with search query
    navigate('/book-flight', { state: { searchQuery } });
  };

  const handleViewFlights = (destination) => {
    navigate('/book-flight', { 
      state: { 
        destination: {
          to: destination.code,
          city: destination.city
        }
      } 
    });
  };

  const handleDestinationClick = (destination) => {
    setSelectedDestination(destination);
  };

  const handleCloseModal = () => {
    setSelectedDestination(null);
  };

  const handleRegionClick = (region) => {
    // Navigate to filtered destinations
    navigate('/book-flight', { 
      state: { 
        region: region.name
      } 
    });
  };

  const handleDealClick = (deal) => {
    navigate('/book-flight', { 
      state: { 
        deal: deal.route
      } 
    });
  };

  const scrollCarousel = (direction) => {
    const carousel = document.querySelector('.deals-carousel');
    if (carousel) {
      const scrollAmount = 400;
      carousel.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="destinations-page">
      <Header />
      
      {/* Hero Section */}
      <section className="destinations-hero-section">
        <div className="hero-background-overlay"></div>
        <div className="page-container">
          <div className="destinations-hero-content">
            <h1 className="destinations-hero-title">Explore Destinations</h1>
            <p className="destinations-hero-subtitle">
              Discover Nigerian and international routes curated for you.
            </p>
            <form onSubmit={handleSearch} className="destinations-search-form">
              <div className="destinations-search-wrapper">
                <span className="search-icon">🔍</span>
                <input
                  type="text"
                  placeholder="Search destinations, airports, or countries…"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="destinations-search-input"
                />
                <button type="submit" className="destinations-search-button">
                  Search
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Popular Nigerian Destinations */}
      <section className="popular-nigerian-section">
        <div className="page-container">
          <div className="section-header">
            <h2 className="section-title">Popular in Nigeria</h2>
            <p className="section-subtitle">
              Top destinations within Nigeria
            </p>
          </div>
          <div className="destinations-grid">
            {nigerianDestinations.map((destination) => (
              <div
                key={destination.id}
                className="destination-card"
                onClick={() => handleDestinationClick(destination)}
              >
                <div className="destination-image-wrapper">
                  <img
                    src={destination.image}
                    alt={destination.city}
                    className="destination-image"
                    loading="lazy"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=800&q=80';
                    }}
                  />
                  <div className="destination-overlay"></div>
                </div>
                <div className="destination-content">
                  <h3 className="destination-city">
                    {destination.city} <span className="destination-code">({destination.code})</span>
                  </h3>
                  <p className="destination-price">From {destination.price}</p>
                  <button
                    className="view-flights-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleViewFlights(destination);
                    }}
                  >
                    View Flights
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trending International Destinations */}
      <section className="trending-international-section">
        <div className="page-container">
          <div className="section-header">
            <h2 className="section-title">Trending International Routes</h2>
            <p className="section-subtitle">
              Popular destinations Nigerians love to visit
            </p>
          </div>
          <div className="destinations-grid">
            {internationalDestinations.map((destination) => (
              <div
                key={destination.id}
                className="destination-card"
                onClick={() => handleDestinationClick(destination)}
              >
                <div className="destination-image-wrapper">
                  <img
                    src={destination.image}
                    alt={destination.city}
                    className="destination-image"
                    loading="lazy"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=800&q=80';
                    }}
                  />
                  <div className="destination-overlay"></div>
                </div>
                <div className="destination-content">
                  <h3 className="destination-city">
                    {destination.city} <span className="destination-code">({destination.code})</span>
                  </h3>
                  <p className="destination-price">From {destination.price}</p>
                  <button
                    className="view-flights-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleViewFlights(destination);
                    }}
                  >
                    View Flights
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Flight Deals Carousel */}
      <section className="flight-deals-section">
        <div className="page-container">
          <div className="section-header">
            <h2 className="section-title">Flight Deals & Top Picks</h2>
            <p className="section-subtitle">
              Exclusive deals for Nigerian travelers
            </p>
          </div>
          <div className="deals-carousel-wrapper">
            <button
              className="carousel-arrow left"
              onClick={() => scrollCarousel('left')}
              aria-label="Scroll left"
            >
              ←
            </button>
            <div className="deals-carousel">
              {flightDeals.map((deal) => (
                <div key={deal.id} className="deal-card">
                  <div className="deal-airline">{deal.airline}</div>
                  <h3 className="deal-route">{deal.route}</h3>
                  <p className="deal-dates">{deal.dates}</p>
                  <div className="deal-price-wrapper">
                    <span className="deal-price">{deal.price}</span>
                    {deal.originalPrice && (
                      <span className="deal-original-price">{deal.originalPrice}</span>
                    )}
                  </div>
                  <button
                    className="see-deal-button"
                    onClick={() => handleDealClick(deal)}
                  >
                    See Deal
                  </button>
                </div>
              ))}
            </div>
            <button
              className="carousel-arrow right"
              onClick={() => scrollCarousel('right')}
              aria-label="Scroll right"
            >
              →
            </button>
          </div>
        </div>
      </section>

      {/* Browse by Region */}
      <section className="browse-region-section">
        <div className="page-container">
          <div className="section-header">
            <h2 className="section-title">Browse by Region</h2>
            <p className="section-subtitle">
              Explore destinations by region
            </p>
          </div>
          <div className="regions-grid">
            {regions.map((region) => (
              <div
                key={region.id}
                className="region-tile"
                onClick={() => handleRegionClick(region)}
              >
                <div className="region-image-wrapper">
                  <img
                    src={region.image}
                    alt={region.name}
                    className="region-image"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                  <div className="region-overlay"></div>
                </div>
                <div className="region-content">
                  <h3 className="region-name">{region.name}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Destination Detail Modal */}
      {selectedDestination && (
        <div className="destination-modal-overlay" onClick={handleCloseModal}>
          <div className="destination-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-button" onClick={handleCloseModal}>
              ×
            </button>
            <div className="modal-image-wrapper">
              <img
                src={selectedDestination.image}
                alt={selectedDestination.city}
                className="modal-image"
              />
            </div>
            <div className="modal-content">
              <h2 className="modal-city">
                {selectedDestination.city} <span className="modal-code">({selectedDestination.code})</span>
              </h2>
              <div className="modal-info-grid">
                <div className="modal-info-item">
                  <span className="modal-info-label">Airport Code</span>
                  <span className="modal-info-value">{selectedDestination.code}</span>
                </div>
                <div className="modal-info-item">
                  <span className="modal-info-label">Popular Airlines</span>
                  <span className="modal-info-value">Multiple carriers</span>
                </div>
                <div className="modal-info-item">
                  <span className="modal-info-label">Best Months</span>
                  <span className="modal-info-value">Year-round</span>
                </div>
                <div className="modal-info-item">
                  <span className="modal-info-label">From Price</span>
                  <span className="modal-info-value price">{selectedDestination.price}</span>
                </div>
              </div>
              <button
                className="modal-search-button"
                onClick={() => {
                  handleViewFlights(selectedDestination);
                  handleCloseModal();
                }}
              >
                Search Flights
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default DestinationsPage;

